module.exports = __webpack_public_path__ + "static/media/logo164.ec63d386.png";